var path = 'msi/spinner/spinner.html';
var html = "<div class=\"og-loading\">\n  <i class=\"fa fa-spinner fa-pulse fa-{{$ctrl.size || '5'}}x fa-fw\"></i>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;